import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { createWebSocketConnection, download_file, fixVulerabilitiesApi, upgradeApi, uploadCodeApi, uploadRepoCodeApi } from "../../end-points/versionUpgrade";

const initialState = {
  data: [],
  status: "idle", // 'idle' | 'connecting' | 'connected' | 'error' | 'closed'
  error: null,
  cloneMessage: "",
  clonePath: "",
  upgradeDetails: {},
  fixVulnerabilityDetails: {},
  vulnerabilityData: [],
  upgradeDone: false,
  zipFile: null
};

let socket;

export const initializeWebSocket = (url) => (dispatch) => {
  dispatch(connecting());

  socket = createWebSocketConnection(
    url,
    () => dispatch(connected()),
    (data) => dispatch(receivedData(data)),
    (error) => dispatch(errorOccurred(error.message)),
    () => dispatch(closed())
  );

};

export const closeWebSocket = () => (dispatch) => {
  if (socket) {
    socket.close();
    dispatch(closed());
  }
};

export const uploadRepoCode = createAsyncThunk(
  "versionUpgrade/uploadRepoCode", uploadRepoCodeApi
)

export const uploadCode = createAsyncThunk(
  "versionUpgrade/uploadCode", uploadCodeApi
)

export const fixVulnerabilities = createAsyncThunk(
  "versionUpgrade/fixVulnerabilities", fixVulerabilitiesApi
)

export const upgrade = createAsyncThunk(
  "versionUpgrade/upgrade", upgradeApi
)

export const downloadZip = createAsyncThunk(
  "versionUpgrade/downloadZip", download_file
);


export const versionUpgradeSlice = createSlice({
  name: "VersionUpgrade",
  initialState,
  reducers: {
    connecting: (state) => {
      console.log("connecting");
      state.status = "connecting";
    },
    connected: (state) => {
      console.log("connected");
      state.status = "connected";
    },
    errorOccurred: (state, action) => {
      state.status = "error";
      state.error = action.payload;
    },
    closed: (state) => {
      state.status = "closed";
    },
    receivedData: (state, action) => {
      if(state.upgradeDone){
        const updatedData = state.vulnerabilityData;
        updatedData.push(action.payload)
        state.vulnerabilityData = updatedData;
      } else{
        const updatedData = state.data;
        updatedData.push(action.payload)
        state.data = updatedData;
      }
    },
    setUploadZipFile: (state, action) => {
      state.zipFile = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(uploadCode.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.upgradeDone = false;
    })
    builder.addCase(uploadCode.fulfilled, (state, action) => {
      console.log("Success in upload code...", state, action.payload);
      state.cloneMessage = action.payload.message;
      state.clonePath = action.payload.data.file_path;
      state.loading = false;
    })
    builder.addCase(uploadCode.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(uploadRepoCode.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.upgradeDone = false;
    })
    builder.addCase(uploadRepoCode.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.cloneMessage = action.payload.message;
      state.clonePath = action.payload.data.zip_path;
      state.loading = false;
    })
    builder.addCase(uploadRepoCode.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(upgrade.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(upgrade.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.upgradeDetails = action.payload.response;
      state.upgradeDone = true;
      state.loading = false;
    })
    builder.addCase(upgrade.rejected, (state, action) => {
      console.log("Error", state, action);
      console.log("Action: ", action.error)
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(fixVulnerabilities.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(fixVulnerabilities.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.fixVulnerabilityDetails = action.payload;
      state.loading = false;
    })
    builder.addCase(fixVulnerabilities.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
    builder.addCase(downloadZip.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(downloadZip.fulfilled, (state, action) => {
      console.log("Success...", state, action.payload);
      window.open(action.payload.file, "_blank", "noopener,noreferrer");
      state.loading = false;
    })
    builder.addCase(downloadZip.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }
})

// Action creators are generated for each case reducer function
export const { connecting,
  connected,
  errorOccurred,
  closed,
  receivedData } = versionUpgradeSlice.actions;

export default versionUpgradeSlice.reducer